var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"hotspot white",style:(_vm.styles),attrs:{"type":"button","id":_vm.area.handle,"title":_vm.area.name}},[_c('span',{staticClass:"plus"},[_vm._v("+")])])
}
var staticRenderFns = []

export { render, staticRenderFns }